import { render, staticRenderFns } from "./AdminBasePipelines.vue?vue&type=template&id=a2492978"
import script from "./AdminBasePipelines.vue?vue&type=script&lang=js"
export * from "./AdminBasePipelines.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports